import React, {useState} from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {AccommodationViewSuggestedHotels} from 'components/Accommodation/SuggestedHotels'
import {SoldOutBodyMessage} from 'components/SearchUnavailability/SoldOut/SoldOutBodyMessage'
import {useShowDatePickerOverlay} from 'hooks/useShowOverlay/useShowOverlay'
import {getAccommodationPageHotelId} from 'modules/accommodation/selectors'

import {Button} from '@vio/atlas/Button'
import {ElephantSad} from '@vio/atlas/foundation/illustrations'
import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {cssTheme} from '@vio/atlas/src/themes'
import {Text} from '@vio/atlas/Text'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {DatePickerType} from '@vio/core/src/datePicker/types'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

const ProviderIconWrapper = styled.div`
  border-radius: 100%;
  width: 60px;
  height: 60px;
  background-color: ${cssTheme.colors.background.neutral.primary};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TopOffersDesktopSoldOut = () => {
  const hotelId = useSelector(getAccommodationPageHotelId)
  const {shell} = useBrandCapabilities()
  const showDatePickerOverlay = useShowDatePickerOverlay()
  const [hasSimilarHotels, setHasSimilarHotels] = useState(true)

  const handleChangeDatesClick = () => {
    window.scrollTo({top: 0, behavior: 'smooth'})
    showDatePickerOverlay(DatePickerType.CheckIn)
  }

  return (
    <Box display="flex" flexDirection="column" gap="s700">
      <Box
        backgroundColor="background.brand.tertiary"
        borderRadius="xl"
        padding="s600"
        display="flex"
        alignItems="center"
        gap="s600"
      >
        {shell.hasFriendlyEmptyState ? (
          <ElephantSad />
        ) : (
          <ProviderIconWrapper>
            <Icon
              size="xl"
              name="Forbid"
              colorPath="content.danger.secondary"
            />
          </ProviderIconWrapper>
        )}
        <Box display="flex" flexDirection="column" gap="s200" flex="1">
          <Text variant="titleXL">
            <FormattedMessageWrapper
              id="topOffers.soldOutForYourDates"
              defaultMessage="Sold out for your dates: {dates}"
              values={{
                dates: <SoldOutBodyMessage showDatesOnly />
              }}
            />
          </Text>
          <Text variant="bodyM" colorPath="content.neutral.secondary">
            <FormattedMessageWrapper
              id="topOffers.soldOutSubtitle"
              defaultMessage="Change your dates or view similar properties"
            />
          </Text>
        </Box>
        <Button
          variant="primary"
          size="xl"
          onClick={handleChangeDatesClick}
          dataId="topOffersSoldOutChangeDatesButton"
        >
          <FormattedMessageWrapper
            id="changeDates"
            defaultMessage="Change dates"
          />
        </Button>
      </Box>
      {hasSimilarHotels && (
        <AccommodationViewSuggestedHotels
          onHotelsLoadingComplete={setHasSimilarHotels}
          hotelId={hotelId}
          hasSideMargin={false}
        />
      )}
    </Box>
  )
}
